import { render, staticRenderFns } from "./Damage.vue?vue&type=template&id=2284b1a4"
import script from "./Damage.vue?vue&type=script&lang=js"
export * from "./Damage.vue?vue&type=script&lang=js"
import style0 from "./Damage.vue?vue&type=style&index=0&id=2284b1a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports